<template>
  <div class="setting-user">
    <div class="index-view-top">
      <van-icon @click="toBack" name="arrow-left" size="28" color="#ffffff" />
      <div class="title">{{ $t("head.setting") }}</div>
      <van-icon style="opacity: 0" name="ellipsis" size="28" color="#ffffff" />
    </div>
    <div class="setting-main">
      <div class="main-item" @click="toPhone()">
        <p>{{ $t("setting.phone") }}</p>
        <div>
          <p>{{ userInfo.phone }}</p>
          <van-icon name="arrow" size="24" color="#999999" />
        </div>
      </div>
      <div class="main-item" @click="loginPassword()">
        <p>{{ $t("setting.updatepwd") }}</p>
        <van-icon name="arrow" size="24" color="#999999" />
      </div>
      <div class="main-item" @click="toAsset()">
        <p>{{ $t("setting.assets_pwd") }}</p>
        <div>
          <p>{{ userInfo.payPwdStatus == '0' ? $t("setting.not") : $t("setting.yes") }}</p>
          <van-icon name="arrow" size="24" color="#999999" />
        </div>
      </div>
      <div class="main-item" @click="toLanguage()">
        <p>{{ $t("setting.language") }}</p>
        <van-icon name="arrow" size="24" color="#999999" />
      </div>
      <div class="main-item" @click="outLogin">
        <p>{{ $t("setting.exit") }}</p>
        <van-icon name="arrow" size="24" color="#999999" />
      </div>
    </div>
  </div>
</template>

<script>
import { info } from "@/utils/request";
export default {
  data() {
    return {
      languageType: "1",
      userInfo: "",
    };
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    //退出登录
    outLogin() {
      localStorage.setItem('token', '')
      this.$router.push("/");
    },
    getUserInfo() {
      info().then((res) => {
        if (res.code == "200") {
          this.userInfo = res.data;
        }
      });
    },
    //修改登录密码
    loginPassword(item) {
      this.$router.push({
        path: "/login",
        query: {
          type: 'login',
        },
      });
    },
    toPhone() {
      this.$router.push("/phone");
    },
    toAsset() {
      if (this.userInfo.payPwdStatus == '0') {
        this.$router.push("/asset");
      } else {
        this.$router.push({
          path: "/login",
          query: {
            type: 'pay',
          },
        });
      }
    },
    toLanguage() {
      this.$router.push("/language");
    },
    toBack() {
      this.$router.push("/user");
    },
  },
};
</script>

<style lang="scss" scoped>
.setting-user {
  width: 100vw;
  height: 100vh;
  background: #0c0b0b;

  .setting-main {
    padding: 0 0.9375rem;

    .main-item {
      height: 3rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 0.0625rem solid #272727;

      >div {
        display: flex;
        align-items: center;

        >p {
          font-size: 0.8125rem;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #999999;
          display: block;
        }
      }

      >p {
        font-size: 0.8125rem;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
      }
    }
  }

  .index-view-top {
    height: 3.625rem;
    padding: 0 0.9375rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title {
      font-size: 1.125rem;
      font-family: PingFang SC-Bold, PingFang SC;
      font-weight: bold;
      color: #ffffff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/user/setting.vue